import(/* webpackMode: "eager", webpackExports: ["Questions"] */ "/app/src/screens/Faq/ui/Questions/Questions.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/Breadcrumbs/Breadcrumbs.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/PageHead/PageHead.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AlertModal"] */ "/app/src/widgets/AlertModal/ui/AlertModal.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/Feedback/ui/Feedback.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Form"] */ "/app/src/widgets/Feedback/ui/Form/Form.tsx");
